export enum AlertaEnum
{
  Success = 1,
  Warning,
  Error,
  Informacion,
}

export enum InformacionEnum
{
  normal = 1
}

export enum DialogoEnum
{
  normal = 1,
  aviso
}

export enum TipoOpcionEnum
{
  positivo = 1,
  negativo
}
